__turbopack_context__.v({
  "blue": "Tag-module-scss-module__F3U4Ma__blue",
  "counter": "Tag-module-scss-module__F3U4Ma__counter",
  "discontinued": "Tag-module-scss-module__F3U4Ma__discontinued",
  "gray": "Tag-module-scss-module__F3U4Ma__gray",
  "green": "Tag-module-scss-module__F3U4Ma__green",
  "medium": "Tag-module-scss-module__F3U4Ma__medium",
  "onDarkBg": "Tag-module-scss-module__F3U4Ma__onDarkBg",
  "root": "Tag-module-scss-module__F3U4Ma__root",
  "saleTimer": "Tag-module-scss-module__F3U4Ma__saleTimer",
  "small": "Tag-module-scss-module__F3U4Ma__small",
  "timerText": "Tag-module-scss-module__F3U4Ma__timerText",
});
